import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@rsos/components/capstone/base';
import { fetchAllPermissions, selectUserOrgByApp } from '@rsos/sinatra';
import RoleAvatar from '../RoleAvatar';
import { AddRoleContainer, RolesAvatarContainer } from './AddRole.styles';
import AddRoleModal from './AddRoleModal';

const AddRole = ({ roles, isMaxRolesCountReached }) => {
  const sinatra = useSelector(state => state.sinatra);
  const dispatch = useDispatch();
  const { application } = sinatra.user.currentRole;
  const org = selectUserOrgByApp(sinatra, application);

  const initialStateFetchStatus = {
    loading: true,
    idle: false,
    error: null,
  };

  const [isAddRoleModalOpened, setIsAddRoleModalOpened] = useState(false);
  const [fetchStatus, setFetchStatus] = useState(initialStateFetchStatus);

  const [permissions, setPermissions] = useState([]);

  const fetchPermissions = () => {
    return dispatch(fetchAllPermissions(org.id, application))
      .then(res => {
        setPermissions(res.permissions);
        setFetchStatus({ loading: false, idle: true, error: null });
      })
      .catch(e => {
        const error = e.error?.response?.data?.detail || 'There was an error';
        setFetchStatus({ idle: false, loading: false, error: error });
      });
  };
  const openAddRoleModal = () => {
    setFetchStatus(initialStateFetchStatus);
    setIsAddRoleModalOpened(true);
    fetchPermissions();
  };

  const refetchPermissions = () => {
    setFetchStatus({ loading: true, idle: false, error: null });
    fetchPermissions();
  };
  const closeAddRoleModal = () => {
    setIsAddRoleModalOpened(false);
  };
  return (
    <AddRoleContainer>
      <RolesAvatarContainer>
        {roles.map(r => (
          <RoleAvatar name={r.name} color={r.avatar_bg_color} key={r.id} />
        ))}
      </RolesAvatarContainer>
      <Button
        btnType="tertiary"
        onClick={openAddRoleModal}
        disabled={isMaxRolesCountReached}
      >
        Add New Role
      </Button>
      <AddRoleModal
        isOpened={isAddRoleModalOpened}
        onClose={closeAddRoleModal}
        permissions={permissions}
        fetchStatus={fetchStatus}
        refetchPermissions={refetchPermissions}
      />
    </AddRoleContainer>
  );
};

export default AddRole;
